/* =========================
   WISHLIST – SINGLE SOURCE
   ========================= */

const WISHLIST_KEY = 'wishlist_items';

/* ---------- Storage ---------- */
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
}

function setWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

/* ---------- Header Update ---------- */
function updateHeaderWishlist() {
  const wishlist = getWishlist();
  const headerBtn = document.querySelector('.action__wishlist');
  if (!headerBtn) return;

  const bubble = headerBtn.querySelector('.wishlist-bubble__text');
  if (!bubble) return;

  bubble.textContent = wishlist.length;
  headerBtn.classList.toggle('wishlist-button--active', wishlist.length > 0);
}

/* ---------- Sync ALL Wishlist Buttons ---------- */
function syncWishlistButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll('[data-wishlist-handle]').forEach(btn => {
    const handle = btn.dataset.wishlistHandle;
    btn.classList.toggle('is-active', wishlist.includes(handle));
    btn.setAttribute(
      'aria-pressed',
      wishlist.includes(handle).toString()
    );
  });
}

/* ---------- Toggle Wishlist ---------- */
function toggleWishlist(handle) {
  let wishlist = getWishlist();

  if (wishlist.includes(handle)) {
    wishlist = wishlist.filter(h => h !== handle);
  } else {
    wishlist.push(handle);
  }

  setWishlist(wishlist);

  // 🔑 Sync everywhere
  updateHeaderWishlist();
  syncWishlistButtons();
}

/* ---------- Click Handling (SINGLE) ---------- */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-handle]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  toggleWishlist(btn.dataset.wishlistHandle);
});

/* ---------- Init ---------- */
function initWishlist() {
  updateHeaderWishlist();
  syncWishlistButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  initWishlist();
}

/* ---------- Expose API ---------- */
window.toggleWishlist = toggleWishlist;
window.getWishlist = getWishlist;


/* ---------- Auto-sync for dynamically loaded buttons (PDP fix) ---------- */
const wishlistObserver = new MutationObserver(() => {
  syncWishlistButtons();
});

wishlistObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
